export default __webpack_public_path__ + "static/media/Flag_of_Namibia.46860825.svg";